<template>
  <div
    class="align-items-end"
    @mouseenter="active = true"
    @mouseleave="active = false"
  >
    <banner-video
      v-if="active && item.video"
      :id="item.id"
      :poster="item?.background || item.cover"
      :src="item.video"
    ></banner-video>
    <div
      v-else
      class="bg-header position-absolute"
      :style="bgStyles"
      @click="irParaConteudo"
    ></div>
  </div>
</template>
<script>
  import BannerVideo from "./BannerVideo.vue";

  export default {
    props: {
      item: {
        type: Object,
        default: () => {},
        required: true,
      },
    },
    components: {
      BannerVideo,
    },
    data() {
      return {
        active: false,
        courseId: null,
        last_lesson_id: null,
      };
    },
    computed: {
      bgStyles() {
        let cover = "";
        cover = this.item?.background || this.item.cover;
        const hasValidLink = this.isUrlValida(this.item?.link);
        return `
        background: url(${cover}), #1b1b1b;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: top center;
        ${hasValidLink ? "cursor: pointer;" : ""}
      `;
      },
    },
    methods: {
      irParaConteudo() {
        const linkBanner = this.item?.link;

        // Verifica se o link é uma URL válida
        if (linkBanner && this.isUrlValida(linkBanner)) {
          window.location.href = linkBanner;
        }
      },
      isUrlValida(url) {
        // Expressão regular para verificar se a string é uma URL válida
        const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w-]*)*\/?$/;
        return urlRegex.test(url);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .banner-space-bottom {
    padding-bottom: 40vh;
  }

  .bg-header {
    height: 654px;
    width: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    @media (max-width: 1520px) {
      height: 615px;
    }
    @media (max-width: 1320px) {
      height: 537px;
    }
    @media (max-width: 1120px) {
      height: 456px;
    }
    @media (max-width: 920px) {
      height: 370px;
    }
    @media (max-width: 720px) {
      height: 300px;
    }
  }

  .wrapper-banner {
    height: 654px;
    position: relative;
    max-width: 100%;
    overflow: hidden;

    @media (max-width: 991px) {
    }
    & * {
      z-index: 1;
    }
    @media (max-width: 1520px) {
      height: 615px;
    }
    @media (max-width: 1320px) {
      height: 537px;
    }
    @media (max-width: 1120px) {
      height: 456px;
    }
    @media (max-width: 920px) {
      height: 370px;
    }
    @media (max-width: 720px) {
      height: 300px;
    }

    video {
      position: absolute;
      top: 50%;
      left: 50%;
      min-width: 100%;
      min-height: 100%;
      width: auto;
      height: auto;
      z-index: 0;
      -ms-transform: translateX(-50%) translateY(-50%);
      -moz-transform: translateX(-50%) translateY(-50%);
      -webkit-transform: translateX(-50%) translateY(-50%);
      transform: translateX(-50%) translateY(-50%);
    }

    .teacher-img {
      border-radius: 50%;
    }

    h1 {
      font-size: 42px;
      line-height: 52px;
    }

    :deep(p) {
      font-size: 14px;
      line-height: 17px;
      color: #d9d9d9;
    }

    h5 {
      font-weight: 600;
      font-size: 12px;
      line-height: 15px;
    }

    .wrapper-infos-aside {
      @media (min-width: 768px) {
        margin-bottom: -3rem;
      }
    }

    .actions {
      &.hide-about {
        justify-content: start !important;
        .about-route {
          display: none !important;
        }

        .btn-primary {
          width: 100%;

          @media (min-width: 992px) {
            margin-right: 1rem;
            max-width: 270px;
          }
        }
      }
    }

    .icon-outline-play,
    .icon-outline-info-circle {
      font-size: 23px;
    }
  }
</style>
